const homepage = document.querySelector(".homepage");
if (homepage) {
    const groupHome = homepage.querySelector(".group-home");

    if (groupHome) {
        groupHome.addEventListener("click", () => {
            document.cookie = "hasSeenAnimation=true; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        });
    }
}
